import { IAgTechAppActionSurfaceConfiguration, IAgTechAppLoading } from "@agtech/core/functions/AgTechAppLoading";
import AgTechErrorMessage from "../../Messaging/AgTechErrorMessage";
import { AgTechLoader } from "../../Pages/Loading/AgTechLoadingSurface";
import AgTechFadeInView from "../../Pages/Loading/AgTechFadeInView";
import AgTechConfirmation from "../../Widgets/AgTechConfirmation";
import { isDev } from "@agtech/core/utilities/AgTechUtilities";

/// Types

export type AgTechWebDataLoader = IAgTechAppLoading;

/// Manager

const AgTechWebActionSurfaceConfiguration: IAgTechAppActionSurfaceConfiguration = {
    renderSurface: props => {
        return (
            <div className="stretched relative row-based flex">
                {props.children}
            </div>
        )
    },
    renderSurfaceBody: props => {
        const opacityClass = props.isOpen ? 'opacity-100' : 'opacity-0'

        return (
            <div className={`stretched fade-changing ${opacityClass} row-based flex`}>
                {props.children}
            </div>
        )
    },
    renderActionSubmission: props => {
        return (
            <div className="stretched absolute bg-transparent container">
                <AgTechLoader text={props.submissionMessage} size={props.loaderSize} />
            </div>
        )
    },
    renderActionConfirmation: props => {
        return (
            <div className="stretched absolute bg-transparent container">
                <AgTechFadeInView>
                    <AgTechConfirmation message={props.confirmationMessage} />
                </AgTechFadeInView>
            </div>
        )
    },
}

export const useAgTechWebDataLoader = (): AgTechWebDataLoader => {
    return {
        showSurface: ({ children, classes, styles }) => {
            return classes || styles ? (
                <div className={classes} style={styles}>
                    {children}
                </div>
            ) : (
                <>{children}</>
            )
        },
        showLoader: loadingText => {
            return <AgTechLoader text={loadingText} />
        },
        showLoadingError: ({ errorMessage, error, retryConfiguration }) => {
            return (
                <AgTechFadeInView classes="centered flex">
                    <AgTechErrorMessage
                        errorMessage={errorMessage}
                        retryConfiguration={retryConfiguration}
                        error={error}
                    />
                </AgTechFadeInView>
            )
        },
        actions: AgTechWebActionSurfaceConfiguration
    }
}